import authRules from '../authRules.js';

const addAssignmentViewActivityType = (user) => {
  const { activityType } = user.securityLevels;
  if (activityType >= authRules.addAssignmentViewActivityType.activityType) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentViewActivityType;
